module.exports = __webpack_public_path__ + "media/components/onboarding/icons/loader-3672e4a0198327dda1afc5adfcb028e8.gif";